"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgShare(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M7.44 6.128a.766.766 0 01.104 1.525l-.104.007H2.787a.255.255 0 00-.248.196l-.007.059v14.298c0 .12.084.222.197.248l.058.007H21.17c.121 0 .222-.084.249-.197l.007-.058V7.915a.255.255 0 00-.197-.249l-.059-.006h-4.652a.766.766 0 01-.104-1.525l.104-.007h4.652c.938 0 1.707.722 1.782 1.64l.005.147v14.298c0 .937-.722 1.707-1.64 1.781L21.17 24H2.787a1.787 1.787 0 01-1.781-1.64L1 22.212V7.915c0-.938.722-1.707 1.64-1.781l.147-.006H7.44zM12.434.15l.086.074 3.064 3.064a.766.766 0 01-.997 1.158L14.5 4.37l-1.757-1.756v12.449a.766.766 0 01-1.524.104l-.007-.104-.001-12.449-1.755 1.756a.766.766 0 01-.998.075l-.086-.075a.766.766 0 01-.074-.997l.074-.086L11.437.224a.766.766 0 01.997-.074z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgShare;
exports.default = _default;